import { MakeServerFn } from './server';
let destroyServer: () => void;
let makeServer: MakeServerFn;

export const EVT_TYPE_STORAGE_CHANGED = 'bread.storageChange';
export const STORAGE_KEY = 'USE_MIRAGE';
const MIRAGE_ENV = 'development';

/**
 * Starts the Mirage server if enabled and not running.
 *
 * @returns Promise<void
 *
 */
export async function startMockAPIServerIfConfigured(): Promise<void> {
  if (shouldUseMockAPI()) {
    await startMockAPIServer();
    console.debug('Mirage Server: Started'); // eslint-disable-line no-console
  } else if (destroyServer) {
    destroyServer();
    console.debug('Mirage Server: Stopped'); // eslint-disable-line no-console
  }
}

/**
 * Determines if Mirage server should be used.
 *
 * @returns boolean
 *
 */
export function shouldUseMockAPI(): boolean {
  try {
    if (typeof window === 'undefined') {
      return false;
    } // Should not run on the server
    let useMockAPI = window.localStorage.getItem(STORAGE_KEY);
    if (!useMockAPI) {
      useMockAPI = process.env.NEXT_PUBLIC_USE_MIRAGE || '';
    }
    return useMockAPI === 'true';
  } catch (e) {
    console.debug('Mirage Server: ' + e); // eslint-disable-line no-console
    return false;
  }
}

async function startMockAPIServer(): Promise<void> {
  if (!makeServer) {
    ({ destroyServer, makeServer } = await import('./server'));
  }
  makeServer({ environment: MIRAGE_ENV });
}
